import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Company from './components/Company';

const company = (props, { t }) => (
  <Container>
    <Company {...props} />
  </Container>
);

company.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(company);
